import log from 'salvo-lite/log'

class SearchForm {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._trigger = elem.previousElementSibling
        log.debug(this.constructor.name, 'Constructed', this)
    }
    onInit () {
        if (window.innerWidth < 769) {
            document.querySelector('.mobile-search').addEventListener('click', e => {
                document.querySelector('.tablet-only .site-header__search-input.snize-input-style').focus()
                console.log(1)
            })
        }
        this._trigger.addEventListener('click', e => {
            if (window.innerWidth > 768) {
                this._elem.querySelector('.site-header__search-input').focus()
            }
            if (document.querySelector('.collection__title')) {
                sessionStorage.removeItem('title')
            }
        })
        this._elem.querySelector('.site-header__search-close').addEventListener('click', e => {
            sessionStorage.setItem('title', document.querySelector('.collection__title').textContent)
        })
    }
}

export default SearchForm



// WEBPACK FOOTER //
// ./src/resources/scripts/components/SearchForm.js